import { JSXConverters } from "@payloadcms/richtext-lexical/react";
import { SerializedParagraphNode } from "@payloadcms/richtext-lexical";
import clsx from "clsx";

export const paragraphConverter: JSXConverters<SerializedParagraphNode> = {

    paragraph: ({ node, nodesToJSX }) => {

        const text = nodesToJSX({ nodes: node.children });
        const joinedText = text.join('');

        const Tag = "p";

        const className = clsx(
            "font-jost text-lg md:text-xl !leading-relaxed whitespace-pre-wrap m-0 py-1 md:py-2"
        );

        const id = joinedText.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')

        return <Tag id={id} className={className}>{text}</Tag>;

    }

}